/**
 * (RTS) Note: The following Policy Group Templates have custom ID properties on
 * them. Over the life of these, some entries were removed and/or added. Due to
 * this, the ID values may appear non-contiguous. This is expected. There is a
 * companion version of this list in SI that requires matching IDs (for now).
 */

const lightSecurityApplePolicyGroupTemplate = {
  id: '1',
  name: 'JumpCloud Light Security - Apple',
  description: 'The Light Security Policy Group is for Admins looking to provide users with a minimally restrictive experience while enforcing critical security against everyday threats with targeted security policies like firewall controls, sign-on requirements, disk encryption, device storage, and configuring account statuses.',
  policies: [
    {
      name: 'JC Light Security - Allow Activation Lock',
      type: 'darwin',
      templateName: 'activation_lock_darwin',
    },
    {
      name: 'JC Light Security - Allow Standard Users To Approve Screen Sharing & Recording',
      type: 'darwin',
      templateName: 'screen_recording_pppc_darwin',
    },
    {
      name: 'JC Light Security - Application Privacy Preferences - Google Chrome Access to User Files',
      type: 'darwin',
      templateName: 'application_privacy_preferences_darwin',
    },
    {
      name: 'JC Light Security - Disable Guest Account',
      type: 'darwin',
      templateName: 'disable_guest_darwin',
    },
    {
      name: 'JC Light Security - FileVault 2',
      type: 'darwin',
      templateName: 'filevault-2_darwin',
    },
    {
      name: 'JC Light Security - Local Firewall Controls',
      type: 'darwin',
      templateName: 'local_firewall_darwin',
    },
    {
      name: 'JC Light Security - Lock Screen - Apple',
      type: 'darwin',
      templateName: 'lock_screen_darwin',
    },
    {
      name: 'JC Light Security - Allow Activation Lock - iOS',
      type: 'ios',
      templateName: 'activation_lock_ios',
    },
    {
      name: 'JC Light Security - Passcode Restrictions',
      type: 'ios',
      templateName: 'passcode_configurable_ios',
    },
    {
      name: 'JC Light Security - Require Passcode for User-Enrolled Devices',
      type: 'ios',
      templateName: 'require_passcode_for_user_enrolled_devices_ios',
    },
  ],
};

const lightSecurityWindowsPolicyGroupTemplate = {
  id: '3',
  name: 'JumpCloud Light Security - Windows',
  description: 'The Light Security Policy Group is for Admins looking to provide users with a minimally restrictive experience while enforcing critical security against everyday threats with targeted security policies like firewall controls, sign-on requirements, disk encryption, device storage, and configuring account statuses.',
  policies: [
    {
      name: 'JC Light Security - Allow The Use of Biometrics',
      type: 'windows',
      templateName: 'allow_the_use_of_biometrics_windows',
    },
    {
      name: 'JC Light Security - BitLocker Full Disk Encryption',
      type: 'windows',
      templateName: 'bitlocker_fde_windows',
    },
    {
      name: 'JC Light Security - Built-in Administrator Account Status',
      type: 'windows',
      templateName: 'builtin_administrator_account_status_windows',
    },
    {
      name: 'JC Light Security - Built-in Guest Account Status',
      type: 'windows',
      templateName: 'disable_guest_windows',
    },
    {
      name: 'JC Light Security - Display User Info When The Session Is Locked',
      type: 'windows',
      templateName: 'display_user_info_when_the_session_is_locked_windows',
    },
    {
      name: 'JC Light Security - Do Not Display Last Username on Logon Screen',
      type: 'windows',
      templateName: 'do_not_display_last_username_windows',
    },
    {
      name: 'JC Light Security - Lock Screen - Windows',
      type: 'windows',
      templateName: 'lock_screen_windows',
    },
    {
      name: 'JC Light Security - Restrict Control Panel Access',
      type: 'windows',
      templateName: 'restrict_control_panel_panes_windows',
    },
    {
      name: 'JC Light Security - Windows Defender',
      type: 'windows',
      templateName: 'windef_windows',
    },
    {
      name: 'JC Light Security - Windows Firewall',
      type: 'windows',
      templateName: 'windowsfirewall_windows',
    },
  ],
};

const lightSecurityLinuxPolicyGroupTemplate = {
  id: '4',
  name: 'JumpCloud Light Security - Linux',
  description: 'The Light Security Policy Group is for Admins looking to provide users with a minimally restrictive experience while enforcing critical security against everyday threats with targeted security policies like firewall controls, sign-on requirements, disk encryption, device storage, and configuring account statuses.',
  policies: [
    {
      name: 'JC Light Security - Check Disk Encryption',
      type: 'linux',
      templateName: 'disk_encryption_check_linux',
    },
    {
      name: 'JC Light Security - Lock Screen - Linux',
      type: 'linux',
      templateName: 'lock_screen_linux',
    },
  ],
};

const standardSecurityApplePolicyGroupTemplate = {
  id: '5',
  name: 'JumpCloud Standard Security - Apple',
  description: 'The Standard Security Policy Group is for Admins looking to provide users with a moderately restrictive experience while enforcing critical security measures. This group contains everything in the Light Security tier plus extra features like file and app-sharing restrictions, secure startup settings, SSH access and security, file ownership, permissions, and storage management.',
  policies: [
    {
      name: 'JC Standard Security - Allow Activation Lock',
      type: 'darwin',
      templateName: 'activation_lock_darwin',
    },
    {
      name: 'JC Standard Security - Allow Standard Users To Approve Screen Sharing & Recording',
      type: 'darwin',
      templateName: 'screen_recording_pppc_darwin',
    },
    {
      name: 'JC Standard Security - Application Privacy Preferences - Google Chrome Access to User Files',
      type: 'darwin',
      templateName: 'application_privacy_preferences_darwin',
    },
    {
      name: 'JC Standard Security - App Notification Settings - Google Chrome',
      type: 'darwin',
      templateName: 'app_notifications_darwin',
    },
    {
      name: 'JC Standard Security - App Store Restrictions',
      type: 'darwin',
      templateName: 'app_store_darwin',
    },
    {
      name: 'JC Standard Security - Block Manual Profile Installation',
      type: 'darwin',
      templateName: 'block_install_profile_darwin',
    },
    {
      name: 'JC Standard Security - Disable Guest Account',
      type: 'darwin',
      templateName: 'disable_guest_darwin',
    },
    {
      name: 'JC Standard Security - Disable iCloud Private Relay',
      type: 'darwin',
      templateName: 'disable_icloud_private_relay_darwin',
    },
    {
      name: 'JC Standard Security - FileVault 2',
      type: 'darwin',
      templateName: 'filevault-2_darwin',
    },
    {
      name: 'JC Standard Security - Gatekeeper Control',
      type: 'darwin',
      templateName: 'gatekeeper_darwin',
    },
    {
      name: 'JC Standard Security - Local Firewall Controls',
      type: 'darwin',
      templateName: 'local_firewall_darwin',
    },
    {
      name: 'JC Standard Security - Lock Screen - Apple',
      type: 'darwin',
      templateName: 'lock_screen_darwin',
    },
    {
      name: 'JC Standard Security - Login Window Text',
      type: 'darwin',
      templateName: 'login_window_text_darwin',
    },
    {
      name: 'JC Standard Security - System Preferences Control',
      type: 'darwin',
      templateName: 'system_preferences_panes_darwin',
    },
    {
      name: 'JC Standard Security - Allow Activation Lock - iOS',
      type: 'ios',
      templateName: 'activation_lock_ios',
    },
    {
      name: 'JC Standard Security - Disable Analytics',
      type: 'ios',
      templateName: 'disable_analytics_ios',
    },
    {
      name: 'JC Standard Security - Disable FaceTime',
      type: 'ios',
      templateName: 'disable_facetime_ios',
    },
    {
      name: 'JC Standard Security - Passcode Restrictions',
      type: 'ios',
      templateName: 'passcode_configurable_ios',
    },
    {
      name: 'JC Standard Security - Require Passcode for User-Enrolled Devices',
      type: 'ios',
      templateName: 'require_passcode_for_user_enrolled_devices_ios',
    },
    {
      name: 'JC Standard Security - Restrict Erase All Contents and Settings',
      type: 'ios',
      templateName: 'disableEACS_control_ios',
    },
    {
      name: 'JC Standard Security - Restrict Sharing Between Managed and Unmanaged Apps',
      type: 'ios',
      templateName: 'managed_app_restrictions_ios',
    },
    {
      name: 'JC Standard Security - Supervised iOS Restrictions',
      type: 'ios',
      templateName: 'supervised_restrictions_ios',
    },
  ],
};

const standardSecurityWindowsPolicyGroupTemplate = {
  id: '7',
  name: 'JumpCloud Standard Security - Windows',
  description: 'The Standard Security Policy Group is for Admins looking to provide users with a moderately restrictive experience while enforcing critical security measures. This group contains everything in the Light Security tier plus extra features like file and app-sharing restrictions, secure startup settings, SSH access and security, file ownership, permissions, and storage management.',
  policies: [
    {
      name: 'JC Standard Security - Allow The Use of Biometrics',
      type: 'windows',
      templateName: 'allow_the_use_of_biometrics_windows',
    },
    {
      name: 'JC Standard Security - BitLocker Full Disk Encryption',
      type: 'windows',
      templateName: 'bitlocker_fde_windows',
    },
    {
      name: 'JC Standard Security - Built-in Administrator Account Status',
      type: 'windows',
      templateName: 'builtin_administrator_account_status_windows',
    },
    {
      name: 'JC Standard Security - Built-in Guest Account Status',
      type: 'windows',
      templateName: 'disable_guest_windows',
    },
    {
      name: 'JC Standard Security - Device Installation',
      type: 'windows',
      templateName: 'devinst_windows',
    },
    {
      name: 'JC Standard Security - Disable Cortana',
      type: 'windows',
      templateName: 'disable_cortana_windows',
    },
    {
      name: 'JC Standard Security - Display User Info When The Session Is Locked',
      type: 'windows',
      templateName: 'display_user_info_when_the_session_is_locked_windows',
    },
    {
      name: 'JC Standard Security - Do Not Display Last Username on Logon Screen',
      type: 'windows',
      templateName: 'do_not_display_last_username_windows',
    },
    {
      name: 'JC Standard Security - Do Not Require CTRL+ALT+DEL on logon screen',
      type: 'windows',
      templateName: 'do_not_require_cad_windows',
    },
    {
      name: 'JC Standard Security - FindMyDevice',
      type: 'windows',
      templateName: 'findMyDevice_windows',
    },
    {
      name: 'JC Standard Security - Lock Screen - Windows',
      type: 'windows',
      templateName: 'lock_screen_windows',
    },
    {
      name: 'JC Standard Security - Message Text For Users Attempting To Log On',
      type: 'windows',
      templateName: 'message_title_text_for_users_attempting_to_logon_windows',
    },
    {
      name: 'JC Standard Security - Remote Assistance',
      type: 'windows',
      templateName: 'remoteassistance_windows',
    },
    {
      name: 'JC Standard Security - Removable Storage',
      type: 'windows',
      templateName: 'removablestorage_windows',
    },
    {
      name: 'JC Standard Security - Restrict Control Panel Access',
      type: 'windows',
      templateName: 'restrict_control_panel_panes_windows',
    },
    {
      name: 'JC Standard Security - Turn Off Autoplay.',
      type: 'windows',
      templateName: 'turn_off_autoplay_windows',
    },
    {
      name: 'JC Standard Security - Windows Defender',
      type: 'windows',
      templateName: 'windef_windows',
    },
    {
      name: 'JC Standard Security - Windows Firewall',
      type: 'windows',
      templateName: 'windowsfirewall_windows',
    },
  ],
};

const standardSecurityLinuxPolicyGroupTemplate = {
  id: '8',
  name: 'JumpCloud Standard Security - Linux',
  description: 'The Standard Security Policy Group is for Admins looking to provide users with a moderately restrictive experience while enforcing critical security measures. This group contains everything in the Light Security tier plus extra features like file and app-sharing restrictions, secure startup settings, SSH access and security, file ownership, permissions, and storage management.',
  policies: [
    {
      name: 'JC Standard Security - Check Disk Encryption',
      type: 'linux',
      templateName: 'disk_encryption_check_linux',
    },
    {
      name: 'JC Standard Security - Disable USB Storage - Linux',
      type: 'linux',
      templateName: 'disable_usb_storage_linux',
    },
    {
      name: 'JC Standard Security - File Ownership and Permissions',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_file_permissions',
    },
    {
      name: 'JC Standard Security - Lock Screen - Linux',
      type: 'linux',
      templateName: 'lock_screen_linux',
    },
    {
      name: 'JC Standard Security - Network Parameters',
      type: 'linux',
      templateName: 'network_parameters_linux',
    },
    {
      name: 'JC Standard Security - Secure Boot Settings',
      type: 'linux',
      templateName: 'secure_boot_settings_linux',
    },
    {
      name: 'JC Standard Security - SSH Root Access',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_ssh_root_access',
    },
    {
      name: 'JC Standard Security - SSH Server Security Enforcement',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_ssh_server_config',
    },
  ],
};

const enhancedSecurityLinuxPolicyGroupTemplate = {
  id: '9',
  name: 'JumpCloud Enhanced Security - Linux',
  description: 'The Enhanced Security Policy Group is for Admins looking to provide significant device protections with maximum restrictions on the end user. The group contains everything in the Light and Standard tiers, plus features like system hardening, app and app store/software restrictions, remote assistance, blocked profile installation, control panel access, and notification settings.',
  policies: [
    {
      name: 'JC Enhanced Security - Additional Process Hardening',
      type: 'linux',
      templateName: 'additional_process_hardening_linux',
    },
    {
      name: 'JC Enhanced Security - Check Disk Encryption',
      type: 'linux',
      templateName: 'disk_encryption_check_linux',
    },
    {
      name: 'JC Enhanced Security - Disable Forbidden Services',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_forbidden_services_linux',
    },
    {
      name: 'JC Enhanced Security - Disable Unused Filesystems',
      type: 'linux',
      templateName: 'disable_unused_filesystems_linux',
    },
    {
      name: 'JC Enhanced Security - Disable USB Storage - Linux',
      type: 'linux',
      templateName: 'disable_usb_storage_linux',
    },
    {
      name: 'JC Enhanced Security - File Ownership and Permissions',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_file_permissions',
    },
    {
      name: 'JC Enhanced Security - Lock Screen - Linux',
      type: 'linux',
      templateName: 'lock_screen_linux',
    },
    {
      name: 'JC Enhanced Security - Network Parameters',
      type: 'linux',
      templateName: 'network_parameters_linux',
    },
    {
      name: 'JC Enhanced Security - Partition and Mount Options',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_partition_options',
    },
    {
      name: 'JC Enhanced Security - Secure Boot Settings',
      type: 'linux',
      templateName: 'secure_boot_settings_linux',
    },
    {
      name: 'JC Enhanced Security - Services Hardening: Service Clients',
      type: 'linux',
      templateName: 'service_clients_linux',
    },
    {
      name: 'JC Enhanced Security - SSH Root Access',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_ssh_root_access',
    },
    {
      name: 'JC Enhanced Security - SSH Server Security Enforcement',
      type: 'linux',
      templateName: 'linux_cis_2_0_0_ssh_server_config',
    },
  ],
};

const enhancedSecurityApplePolicyGroupTemplate = {
  id: '10',
  name: 'JumpCloud Enhanced Security - Apple',
  description: 'The Enhanced Security Policy Group is for Admins looking to provide significant device protections with maximum restrictions on the end user. The group contains everything in the Light and Standard tiers, plus features like system hardening, app and app store/software restrictions, remote assistance, blocked profile installation, control panel access, and notification settings.',
  policies: [
    {
      name: 'JC Enhanced Security - Allow Activation Lock',
      type: 'darwin',
      templateName: 'activation_lock_darwin',
    },
    {
      name: 'JC Enhanced Security - Allow Standard Users To Approve Screen Sharing & Recording',
      type: 'darwin',
      templateName: 'screen_recording_pppc_darwin',
    },
    {
      name: 'JC Enhanced Security - Application Privacy Preferences - Google Chrome Access to User Files',
      type: 'darwin',
      templateName: 'application_privacy_preferences_darwin',
    },
    {
      name: 'JC Enhanced Security - App Notification Settings',
      type: 'darwin',
      templateName: 'app_notifications_darwin',
    },
    {
      name: 'JC Enhanced Security - App Store Restrictions',
      type: 'darwin',
      templateName: 'app_store_darwin',
    },
    {
      name: 'JC Enhanced Security - Block iCloud Access',
      type: 'darwin',
      templateName: 'icloud_access_darwin',
    },
    {
      name: 'JC Enhanced Security - Block Manual Profile Installation',
      type: 'darwin',
      templateName: 'block_install_profile_darwin',
    },
    {
      name: 'JC Enhanced Security - Disable Content Caching',
      type: 'darwin',
      templateName: 'disable_content_caching_darwin',
    },
    {
      name: 'JC Enhanced Security - Disable Guest Account',
      type: 'darwin',
      templateName: 'disable_guest_darwin',
    },
    {
      name: 'JC Enhanced Security - Disable iCloud Private Relay',
      type: 'darwin',
      templateName: 'disable_icloud_private_relay_darwin',
    },
    {
      name: 'JC Enhanced Security - Disable Siri',
      type: 'darwin',
      templateName: 'disable_siri_darwin',
    },
    {
      name: 'JC Enhanced Security - FileVault 2',
      type: 'darwin',
      templateName: 'filevault-2_darwin',
    },
    {
      name: 'JC Enhanced Security - Gatekeeper Control',
      type: 'darwin',
      templateName: 'gatekeeper_darwin',
    },
    {
      name: 'JC Enhanced Security - Local Firewall Controls',
      type: 'darwin',
      templateName: 'local_firewall_darwin',
    },
    {
      name: 'JC Enhanced Security - Lock Screen - Apple',
      type: 'darwin',
      templateName: 'lock_screen_darwin',
    },
    {
      name: 'JC Enhanced Security - Login Window Controls',
      type: 'darwin',
      templateName: 'login_window_control_darwin',
    },
    {
      name: 'JC Enhanced Security - Login Window Text',
      type: 'darwin',
      templateName: 'login_window_text_darwin',
    },
    {
      name: 'JC Enhanced Security - Restrict Erase All Contents and Settings',
      type: 'darwin',
      templateName: 'restrictEACS_control_darwin',
    },
    {
      name: 'JC Enhanced Security - System Preferences Control',
      type: 'darwin',
      templateName: 'system_preferences_panes_darwin',
    },
    {
      name: 'JC Enhanced Security - Allow Activation Lock - iOS',
      type: 'ios',
      templateName: 'activation_lock_ios',
    },
    {
      name: 'JC Enhanced Security - Passcode Restrictions',
      type: 'ios',
      templateName: 'passcode_configurable_ios',
    },
    {
      name: 'JC Enhanced Security - Require Passcode for User-Enrolled Devices',
      type: 'ios',
      templateName: 'require_passcode_for_user_enrolled_devices_ios',
    },
    {
      name: 'JC Enhanced Security - Restrict Erase All Contents and Settings Policy',
      type: 'ios',
      templateName: 'disableEACS_control_ios',
    },
    {
      name: 'JC Enhanced Security - Restrict Sharing Between Managed and Unmanaged Apps',
      type: 'ios',
      templateName: 'managed_app_restrictions_ios',
    },
    {
      name: 'JC Enhanced Security - Supervised iOS Restrictions',
      type: 'ios',
      templateName: 'supervised_restrictions_ios',
    },
  ],
};

const enhancedSecurityWindowsPolicyGroupTemplate = {
  id: '12',
  name: 'JumpCloud Enhanced Security - Windows',
  description: 'The Enhanced Security Policy Group is for Admins looking to provide significant device protections with maximum restrictions on the end user. The group contains everything in the Light and Standard tiers, plus features like system hardening, app and app store/software restrictions, remote assistance, blocked profile installation, control panel access, and notification settings.',
  policies: [
    {
      name: 'JC Enhanced Security - Allow The Use of Biometrics',
      type: 'windows',
      templateName: 'allow_the_use_of_biometrics_windows',
    },
    {
      name: 'JC Enhanced Security - BitLocker Full Disk Encryption',
      type: 'windows',
      templateName: 'bitlocker_fde_windows',
    },
    {
      name: 'JC Enhanced Security - Built-in Administrator Account Status',
      type: 'windows',
      templateName: 'builtin_administrator_account_status_windows',
    },
    {
      name: 'JC Enhanced Security - Built-in Guest Account Status',
      type: 'windows',
      templateName: 'disable_guest_windows',
    },
    {
      name: 'JC Enhanced Security - Control Panel Display',
      type: 'windows',
      templateName: 'controlpaneldisplay_windows',
    },
    {
      name: 'JC Enhanced Security - Device Installation',
      type: 'windows',
      templateName: 'devinst_windows',
    },
    {
      name: 'JC Enhanced Security - Disable Cortana',
      type: 'windows',
      templateName: 'disable_cortana_windows',
    },
    {
      name: 'JC Enhanced Security - Disable Windows Store Application',
      type: 'windows',
      templateName: 'disable_windows_store_application_windows',
    },
    {
      name: 'JC Enhanced Security - Display User Info When The Session Is Locked',
      type: 'windows',
      templateName: 'display_user_info_when_the_session_is_locked_windows',
    },
    {
      name: 'JC Enhanced Security - Do Not Display Last Username on Logon Screen',
      type: 'windows',
      templateName: 'do_not_display_last_username_windows',
    },
    {
      name: 'JC Enhanced Security - Do Not Require CTRL+ALT+DEL on logon screen',
      type: 'windows',
      templateName: 'do_not_require_cad_windows',
    },
    {
      name: 'JC Enhanced Security - Lock Screen - Windows',
      type: 'windows',
      templateName: 'lock_screen_windows',
    },
    {
      name: 'JC Enhanced Security - Logon Behaviors',
      type: 'windows',
      templateName: 'logon_windows',
    },
    {
      name: 'JC Enhanced Security - Message Text For Users Attempting To Log On',
      type: 'windows',
      templateName: 'message_title_text_for_users_attempting_to_logon_windows',
    },
    {
      name: 'JC Enhanced Security - Remote Assistance',
      type: 'windows',
      templateName: 'remoteassistance_windows',
    },
    {
      name: 'JC Enhanced Security - Removable Storage',
      type: 'windows',
      templateName: 'removablestorage_windows',

    },
    {
      name: 'JC Enhanced Security - Rename Local Administrator Account Policy',
      type: 'windows',
      templateName: 'rename_local_administrator_account_windows',
    },
    {
      name: 'JC Enhanced Security - Restrict Control Panel Access',
      type: 'windows',
      templateName: 'restrict_control_panel_panes_windows',
    },
    {
      name: 'JC Enhanced Security - Software Restrictions',
      type: 'windows',
      templateName: 'software_restrictions_windows',
    },
    {
      name: 'JC Enhanced Security - Turn Off Autoplay.',
      type: 'windows',
      templateName: 'turn_off_autoplay_windows',
    },
    {
      name: 'JC Enhanced Security - Windows Defender',
      type: 'windows',
      templateName: 'windef_windows',
    },
    {
      name: 'JC Enhanced Security - Windows Firewall',
      type: 'windows',
      templateName: 'windowsfirewall_windows',
    },
  ],
};

/**
 * The following array is ordered in the manner we require for
 * display. Any new policy group templates added must be ordered appropriately
 * either above, below, or properly within the existing order.
 * @see https://jumpcloud.atlassian.net/browse/MSP-1409
 */
const policyGroupTemplates = [
  lightSecurityApplePolicyGroupTemplate,
  lightSecurityWindowsPolicyGroupTemplate,
  lightSecurityLinuxPolicyGroupTemplate,
  standardSecurityApplePolicyGroupTemplate,
  standardSecurityWindowsPolicyGroupTemplate,
  standardSecurityLinuxPolicyGroupTemplate,
  enhancedSecurityApplePolicyGroupTemplate,
  enhancedSecurityWindowsPolicyGroupTemplate,
  enhancedSecurityLinuxPolicyGroupTemplate,
];

export default policyGroupTemplates;
